export const itsatrapmodal = () => {
    $('#dynamicModalContainer').on('shown.bs.modal', function() {
      if ($(this).find('#limited_availability_modal').length > 0) {
        $(this).find('[data-dismiss="modal"]').remove();
      }
    });
    $('#dynamicModalContainer').on('hide.bs.modal', function(e) {
      if ($(this).find('#limited_availability_modal').length > 0) {
        e.preventDefault();
      }
    });
}
